
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/downloadarea",
      function () {
        return require("private-next-pages/downloadarea/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/downloadarea"])
      });
    }
  